import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import Footer from './components/layout/Footer';

import './global.css';
import 'react-toastify/dist/ReactToastify.css';
import './app.css';

import { WalletSelectorContextProvider } from './context/WalletSelectorContext';

import { Content } from 'src/Content';
import { LedgerTransactionModal } from './context/modal-ui/setupModal';
function App() {
  return (
    <Router>
      <WalletSelectorContextProvider>
        <div className="page-container relative min-h-screen flex flex-col bg-black">
          <img className="page-bg" src="/bg.jpg" alt="" aria-hidden="true" />
          <div className="relative z-10 flex flex-col flex-1 min-h-screen">
            <div className="flex-1 pb-8 lg:overflow-x-hidden">
              <Content />
            </div>
            <Footer />
          </div>
        </div>
      </WalletSelectorContextProvider>
      <LedgerTransactionModal />
    </Router>
  );
}

export default App;
